import React, { useEffect, useState, useRef, createElement } from 'react';
import { CheckCircle2, Lock, User, Mail, Phone, Globe, X, ArrowRight, Clock, TrendingUp, DollarSign, Zap, Target, Users, Video, Calendar, Ticket, Search, Bot, MessageSquare, Mic, Quote, AlertTriangle, ShieldCheck, Car, Briefcase, HelpCircle, Frown, Sparkles, XCircle, Monitor, Check, CalendarPlus, MessageCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
const COUNTRY_CODES = [{
  code: '+1',
  country: 'USA/Canada'
}, {
  code: '+52',
  country: 'México'
}, {
  code: '+57',
  country: 'Colombia'
}, {
  code: '+34',
  country: 'España'
}, {
  code: '+54',
  country: 'Argentina'
}, {
  code: '+56',
  country: 'Chile'
}, {
  code: '+51',
  country: 'Perú'
}, {
  code: '+593',
  country: 'Ecuador'
}, {
  code: '+58',
  country: 'Venezuela'
}, {
  code: '+502',
  country: 'Guatemala'
}, {
  code: '+503',
  country: 'El Salvador'
}, {
  code: '+504',
  country: 'Honduras'
}, {
  code: '+505',
  country: 'Nicaragua'
}, {
  code: '+506',
  country: 'Costa Rica'
}, {
  code: '+507',
  country: 'Panamá'
}, {
  code: '+591',
  country: 'Bolivia'
}, {
  code: '+595',
  country: 'Paraguay'
}, {
  code: '+598',
  country: 'Uruguay'
}, {
  code: '+1-809',
  country: 'Rep. Dominicana'
}];
const getNextThursdayDate = () => {
  const now = new Date();
  const estTime = new Date(now.toLocaleString('en-US', {
    timeZone: 'America/New_York'
  }));
  const currentDay = estTime.getDay();
  const currentHour = estTime.getHours();
  let daysUntilThursday = 0;
  if (currentDay === 4) {
    daysUntilThursday = currentHour >= 19 ? 7 : 0;
  } else if (currentDay < 4) {
    daysUntilThursday = 4 - currentDay;
  } else {
    daysUntilThursday = 7 - currentDay + 4;
  }
  const next = new Date(estTime);
  next.setDate(estTime.getDate() + daysUntilThursday);
  next.setHours(19, 0, 0, 0);
  return next;
};
const getThursdayLabel = () => {
  const t = getNextThursdayDate();
  const day = t.getDate();
  const month = t.toLocaleString('es-ES', {
    month: 'long'
  }).toUpperCase();
  return `JUEVES ${day} DE ${month}`;
};
export function EscapaDelDealershipGraciasPage() {
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [areaCode, setAreaCode] = useState('+1');
  const [phone, setPhone] = useState('');
  const [smsConsent, setSmsConsent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const navigate = useNavigate();
  const nameRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    window.fbq('trackCustom', 'EscapaDelDealership-GraciasView');
    const tick = () => {
      const estNow = new Date(new Date().toLocaleString('en-US', {
        timeZone: 'America/New_York'
      }));
      const currentDay = estNow.getDay();
      const currentHour = estNow.getHours();
      let daysUntil = 0;
      if (currentDay === 4) {
        daysUntil = currentHour >= 19 ? 7 : 0;
      } else if (currentDay < 4) {
        daysUntil = 4 - currentDay;
      } else {
        daysUntil = 7 - currentDay + 4;
      }
      const estTarget = new Date(estNow);
      estTarget.setDate(estNow.getDate() + daysUntil);
      estTarget.setHours(19, 0, 0, 0);
      let diffMs = estTarget.getTime() - estNow.getTime();
      if (diffMs < 0) diffMs = 0;
      const days = Math.floor(diffMs / 86400000);
      const hours = Math.floor(diffMs % 86400000 / 3600000);
      const minutes = Math.floor(diffMs % 3600000 / 60000);
      const seconds = Math.floor(diffMs % 60000 / 1000);
      setCountdown({
        days,
        hours,
        minutes,
        seconds
      });
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;
    const finalName = nameRef.current?.value?.trim() || name.trim();
    const finalEmail = emailRef.current?.value?.trim() || email.trim();
    const finalPhone = phoneRef.current?.value?.replace(/\D/g, '').trim() || phone.trim();
    if (!finalName || finalName.length < 2) {
      alert('Por favor ingresa tu nombre completo');
      return;
    }
    if (!finalEmail || !finalEmail.includes('@')) {
      alert('Por favor ingresa un email válido');
      return;
    }
    if (!finalPhone || finalPhone.length < 7) {
      alert('Por favor ingresa tu teléfono');
      return;
    }
    if (!smsConsent) {
      alert('Por favor marca la casilla de consentimiento de SMS para continuar.');
      return;
    }
    setIsSubmitting(true);
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', {
          content_name: 'Escapa Dealership Webinar Registration'
        });
      }
      const webhookUrl = 'https://services.leadconnectorhq.com/hooks/HMYR0XQcpZnIeoWD2nrn/webhook-trigger/9e77fbea-dfb7-4800-9398-1f4c8701198d';
      await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: finalName,
          email: finalEmail,
          phone: `${areaCode}${finalPhone}`,
          first_name: finalName.split(' ')[0],
          last_name: finalName.split(' ').slice(1).join(' ') || finalName.split(' ')[0],
          full_name: finalName,
          fullPhone: `${areaCode}${finalPhone}`,
          areaCode: areaCode,
          source: '/escapa-del-dealership-gracias',
          page_path: '/escapa-del-dealership-gracias',
          tag: 'escapa-dealership-webinar',
          sms_consent: smsConsent,
          event_time: Math.floor(Date.now() / 1000),
          event_source_url: window.location.href,
          action_source: 'website'
        })
      });
      navigate('/thank-you');
    } catch (err) {
      console.error('Submit error:', err);
      navigate('/thank-you');
    } finally {
      setIsSubmitting(false);
    }
  };
  const blocks = [{
    icon: Search,
    label: 'BLOQUE 1',
    title: 'La Herramienta En Vivo',
    desc: 'Voy a llenar una lista de 200 dentistas en TU ciudad en menos de 1 minuto. Vas a ver el botón "buscar" y la lista apareciendo. No es magia — es scraping inteligente.'
  }, {
    icon: Bot,
    label: 'BLOQUE 2',
    title: 'Construyo Web Completa Delante Tuyo',
    desc: 'Tomo UN cliente real con permiso. Y delante tuyo armo su web profesional completa con IA. Vas a entender por qué cobramos $1,500.'
  }, {
    icon: MessageSquare,
    label: 'BLOQUE 3',
    title: 'Los Mensajes Que Cierran (Para Vendedores)',
    desc: 'Específicamente para car salesmen: cómo aplicas tu técnica de cierre del showroom a este nuevo contexto. Pantallazos REALES de WhatsApp donde alumnos cerraron $1,200 con UN mensaje.'
  }, {
    icon: Mic,
    label: 'BLOQUE 4',
    title: 'Q&A De 30 Minutos En Vivo',
    desc: 'TÚ me preguntas. Sobre tu ciudad. Tu situación específica. Te respondo en tiempo real.'
  }];
  const thursdayLabel = getThursdayLabel();
  return <div className="min-h-screen bg-[#0a1428] text-white font-sans selection:bg-amber-400 selection:text-[#0a1428] overflow-x-hidden" data-id="element-1703">
      <noscript data-id="element-1704">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-1705" />
      </noscript>

      {/* Background Image Layer */}
      <div className="absolute top-0 left-0 w-full h-[400px] md:h-[600px] z-0 opacity-60 pointer-events-none" data-id="element-1706">
        <img src="https://cdn.magicpatterns.com/uploads/owSR6X5Pw8KuRfkif7sGzk/6936d7f7169a421d1ba8a294.png" alt="Background Pattern" className="w-full h-full object-cover" style={{
        maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)'
      }} data-id="element-1707" />
      </div>

      {/* Ambient glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[600px] bg-amber-500/[0.08] blur-[140px] rounded-full pointer-events-none" data-id="element-1708" />
      <div className="absolute top-[40%] right-0 w-[500px] h-[500px] bg-amber-400/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-1709" />
      <div className="absolute top-[10%] left-0 w-[400px] h-[400px] bg-blue-500/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-1710" />

      <div className="absolute inset-0 opacity-[0.015] pointer-events-none" style={{
      backgroundImage: 'linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-1711" />

      {/* ============ FLOATING HEADER ============ */}
      <header className="fixed top-3 md:top-5 left-0 right-0 z-50 px-3 md:px-6 pointer-events-none" data-id="element-1712">
        <div className="max-w-5xl mx-auto pointer-events-auto" data-id="element-1713">
          <div className="relative bg-[#0f1b35]/80 backdrop-blur-xl border border-amber-500/25 rounded-full shadow-[0_10px_40px_-10px_rgba(0,0,0,0.6),0_0_30px_-10px_rgba(245,158,11,0.3)]" data-id="element-1714">
            <div className="flex items-center justify-between gap-3 pl-3 pr-2 md:pl-5 md:pr-2.5 py-2 md:py-2.5" data-id="element-1715">
              <div className="flex items-center gap-2.5 min-w-0" data-id="element-1716">
                <div className="flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-full bg-amber-500/15 border border-amber-500/40 flex-shrink-0" data-id="element-1717">
                  <Video className="w-4 h-4 md:w-[18px] md:h-[18px] text-amber-400" data-id="element-1718" />
                </div>
                <div className="flex flex-col leading-none min-w-0" data-id="element-1719">
                  <span className="text-amber-400 text-[9px] md:text-[10px] font-black uppercase tracking-[0.18em] leading-none" data-id="element-1720">
                    Webinar Gratuito
                  </span>
                  <span className="text-white text-xs md:text-sm font-black tracking-tight mt-1 truncate" data-id="element-1721">
                    Escapa del Dealership
                  </span>
                </div>
              </div>

              <div className="hidden lg:flex items-center gap-2 px-3" data-id="element-1722">
                <Calendar className="w-3.5 h-3.5 text-amber-400/70 flex-shrink-0" data-id="element-1723" />
                <span className="text-gray-300 text-xs font-bold uppercase tracking-[0.12em] leading-none whitespace-nowrap" data-id="element-1724">
                  {thursdayLabel}
                </span>
                <span className="inline-block w-px h-3.5 bg-amber-500/25" data-id="element-1725" />
                <Clock className="w-3.5 h-3.5 text-amber-400/70 flex-shrink-0" data-id="element-1726" />
                <span className="text-gray-300 text-xs font-bold uppercase tracking-[0.12em] leading-none whitespace-nowrap" data-id="element-1727">
                  7PM EST
                </span>
              </div>

              <button type="button" onClick={() => setShowModal(true)} className="group flex items-center gap-1.5 md:gap-2 bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-[10px] md:text-xs uppercase tracking-tight rounded-full px-3.5 md:px-5 py-2 md:py-2.5 shadow-[0_8px_25px_-8px_rgba(245,158,11,0.6)] hover:shadow-[0_8px_25px_-5px_rgba(245,158,11,0.8)] transition-all duration-300 flex-shrink-0 whitespace-nowrap" data-id="element-1728">
                <Ticket className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-1729" />
                <span className="hidden sm:inline" data-id="element-1730">Reservar Cupo</span>
                <span className="sm:hidden" data-id="element-1731">Reservar</span>
                <ArrowRight className="w-3.5 h-3.5 md:w-4 md:h-4 transition-transform group-hover:translate-x-0.5" data-id="element-1732" />
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="relative z-10 max-w-7xl mx-auto px-4 lg:px-8 pt-24 md:pt-28 lg:pt-24 pb-10" data-id="element-1733">
        {/* ============ HERO ============ */}
        <section className="mb-8 md:mb-14 lg:mb-18 text-center" data-id="element-1734">
          <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-3.5 py-1.5 mb-4 md:mb-8" data-id="element-1735">
            <span className="text-emerald-400 text-[11px] md:text-sm font-black uppercase tracking-[0.18em] leading-none" data-id="element-1736">
              DESCARGA CONFIRMADA ✅
            </span>
          </div>

          <h1 className="text-[26px] md:text-5xl lg:text-6xl font-black leading-[1.05] tracking-tight mb-3 md:mb-5 lg:mb-6 max-w-5xl mx-auto" data-id="element-1737">
            ¡Listo Hermano! Tu Guía Va En{' '}
            <span className="relative inline-block" data-id="element-1738">
              <span className="relative z-10 text-amber-400" data-id="element-1739">
                Camino A Tu Email
              </span>
              <span className="absolute bottom-1 left-0 w-full h-3 bg-amber-400/15 -z-0 rounded-sm" data-id="element-1740" />
            </span>
          </h1>

          {/* ============ VIDEO — moved directly under headline ============ */}
          <div className="max-w-4xl mx-auto mb-4 md:mb-8 lg:mb-10" data-id="element-1741">
            <div className="relative aspect-video rounded-xl md:rounded-2xl overflow-hidden border-2 border-amber-500/30 shadow-[0_0_50px_rgba(245,158,11,0.15)] bg-[#0f1b35] flex items-center justify-center" data-id="element-1742">
              {/* Video Placeholder */}
              <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center" data-id="element-1743">
                <div className="w-14 h-14 md:w-20 md:h-20 bg-amber-500 rounded-full flex items-center justify-center mb-2 md:mb-4 cursor-pointer hover:scale-110 transition-transform shadow-[0_0_30px_rgba(245,158,11,0.5)]" data-id="element-1744">
                  <div className="w-0 h-0 border-t-[9px] md:border-t-[12px] border-t-transparent border-l-[14px] md:border-l-[20px] border-l-[#0a1428] border-b-[9px] md:border-b-[12px] border-b-transparent ml-1.5 md:ml-2" data-id="element-1745"></div>
                </div>
                <span className="text-white font-bold text-sm md:text-lg" data-id="element-1746">
                  Ver Video
                </span>
              </div>
            </div>
          </div>

          <p className="text-sm md:text-lg lg:text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto mb-6 md:mb-10" data-id="element-1747">
            Te mandé "Escapa del Dealership" a tu email AHORA. Debería llegar en
            menos de 60 segundos. Si no lo ves, revisa tu carpeta de spam.
          </p>

          {/* ============ SECTION 2 — Transition to webinar pitch ============ */}
          <div className="max-w-4xl mx-auto pt-2 md:pt-0 border-t border-white/5 md:border-0" data-id="element-1748">
            <div className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-amber-500/10 border border-amber-500/30 rounded-full mt-6 md:mt-0 mb-3 md:mb-6" data-id="element-1749">
              <Zap className="w-5 h-5 md:w-6 md:h-6 text-amber-400" data-id="element-1750" />
            </div>
            <h2 className="text-[clamp(0.95rem,4.2vw,1.25rem)] md:text-3xl lg:text-4xl font-black leading-[1.15] tracking-tight whitespace-nowrap mb-2.5 md:mb-4" data-id="element-1751">
              Pero Antes De Que Te Vayas A Leer El PDF...
            </h2>
            <p className="text-sm md:text-lg text-gray-300 leading-relaxed" data-id="element-1752">
              Reservé algo más para ti — el webinar{' '}
              <span className="inline-flex items-center gap-1.5 align-baseline" data-id="element-1753">
                <span className="relative flex h-2 w-2 md:h-2.5 md:w-2.5" data-id="element-1754">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-1755" />
                  <span className="relative inline-flex rounded-full h-2 w-2 md:h-2.5 md:w-2.5 bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.8)]" data-id="element-1756" />
                </span>
                <span className="font-black text-red-400 tracking-wide uppercase text-xs md:text-sm" data-id="element-1757">
                  EN VIVO
                </span>
              </span>{' '}
              va a cambiar cómo lees la guía.
            </p>
          </div>
        </section>

        {/* ============ SECTION 3 — Por Qué El PDF Solo No Es Suficiente ============ */}
        <section className="mb-10 md:mb-14 lg:mb-18" data-id="element-1758">
          <div className="max-w-5xl mx-auto" data-id="element-1759">
            <div className="text-center mb-5 md:mb-6 lg:mb-8" data-id="element-1760">
              <h2 className="text-xl md:text-3xl lg:text-4xl font-black leading-[1.15] mb-3 md:mb-4" data-id="element-1761">
                Lo Que El PDF{' '}
                <span className="text-amber-400" data-id="element-1762">NO Puede Hacer</span> Por Ti
              </h2>
              <p className="text-sm md:text-lg text-gray-300" data-id="element-1763">
                El PDF tiene el QUÉ. El webinar tiene el CÓMO.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-6" data-id="element-1764">
              {/* PDF Column */}
              <div className="bg-white/[0.03] border border-white/[0.08] rounded-3xl p-5 md:p-6 lg:p-8" data-id="element-1765">
                <div className="flex items-center gap-3 mb-6" data-id="element-1766">
                  <div className="text-2xl" data-id="element-1767">📖</div>
                  <h3 className="text-xl md:text-2xl font-black text-white" data-id="element-1768">
                    EL PDF{' '}
                    <span className="text-gray-400 text-lg font-bold" data-id="element-1769">
                      (lo que descargaste):
                    </span>
                  </h3>
                </div>
                <ul className="space-y-2.5" data-id="element-1770">
                  <li className="flex items-center gap-3 text-gray-300" data-id="element-1771">
                    <CheckCircle2 className="w-5 h-5 text-emerald-400 flex-shrink-0" data-id="element-1772" />
                    <span data-id="element-1773">Te explica el modelo</span>
                  </li>
                  <li className="flex items-center gap-3 text-gray-300" data-id="element-1774">
                    <CheckCircle2 className="w-5 h-5 text-emerald-400 flex-shrink-0" data-id="element-1775" />
                    <span data-id="element-1776">Te muestra los nichos</span>
                  </li>
                  <li className="flex items-center gap-3 text-gray-300" data-id="element-1777">
                    <CheckCircle2 className="w-5 h-5 text-emerald-400 flex-shrink-0" data-id="element-1778" />
                    <span data-id="element-1779">Te da los mensajes</span>
                  </li>
                  <li className="flex items-center gap-3 text-gray-400 opacity-70 mt-6" data-id="element-1780">
                    <X className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-1781" />
                    <span data-id="element-1782">NO muestra la herramienta funcionando</span>
                  </li>
                  <li className="flex items-center gap-3 text-gray-400 opacity-70" data-id="element-1783">
                    <X className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-1784" />
                    <span data-id="element-1785">NO muestra el software construyendo</span>
                  </li>
                  <li className="flex items-center gap-3 text-gray-400 opacity-70" data-id="element-1786">
                    <X className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-1787" />
                    <span data-id="element-1788">NO responde tus dudas específicas</span>
                  </li>
                </ul>
              </div>

              {/* Webinar Column */}
              <div className="bg-gradient-to-br from-amber-950/30 to-[#0a1428] border-2 border-amber-500/40 rounded-3xl p-5 md:p-6 lg:p-8 shadow-[0_0_40px_rgba(245,158,11,0.1)] relative overflow-hidden" data-id="element-1789">
                <div className="absolute top-0 right-0 w-32 h-32 bg-amber-400/10 blur-3xl rounded-full" data-id="element-1790" />
                <div className="relative z-10" data-id="element-1791">
                  <div className="flex items-center gap-3 mb-6" data-id="element-1792">
                    <div className="text-2xl" data-id="element-1793">🎯</div>
                    <h3 className="text-xl md:text-2xl font-black text-amber-400" data-id="element-1794">
                      EL WEBINAR EN VIVO:
                    </h3>
                  </div>
                  <p className="text-white font-bold mb-4" data-id="element-1795">
                    Todo lo del PDF MÁS:
                  </p>
                  <ul className="space-y-2.5" data-id="element-1796">
                    <li className="flex items-center gap-3 text-white font-medium" data-id="element-1797">
                      <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0" data-id="element-1798" />
                      <span data-id="element-1799">Demo EN VIVO de la herramienta</span>
                    </li>
                    <li className="flex items-center gap-3 text-white font-medium" data-id="element-1800">
                      <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0" data-id="element-1801" />
                      <span data-id="element-1802">Construyo web completa delante tuyo</span>
                    </li>
                    <li className="flex items-center gap-3 text-white font-medium" data-id="element-1803">
                      <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0" data-id="element-1804" />
                      <span data-id="element-1805">Casos REALES con números reales</span>
                    </li>
                    <li className="flex items-center gap-3 text-white font-medium" data-id="element-1806">
                      <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0" data-id="element-1807" />
                      <span data-id="element-1808">Q&A 30 min — TUS preguntas</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="mt-10 bg-white/[0.02] border border-white/[0.05] rounded-2xl p-6 text-center max-w-3xl mx-auto" data-id="element-1809">
              <p className="text-gray-300 text-lg leading-relaxed" data-id="element-1810">
                Los que leen el PDF y NO van al webinar:{' '}
                <span className="text-white font-bold" data-id="element-1811">
                  5% logra resultados.
                </span>
                <br data-id="element-1812" />
                Los que leen el PDF Y van al webinar:{' '}
                <span className="text-amber-400 font-black text-xl" data-id="element-1813">
                  40% logra resultados.
                </span>
              </p>
            </div>
          </div>
        </section>

        {/* ============ SECTION 4 — Los 4 Bloques Del Webinar ============ */}
        <section className="mb-10 md:mb-14 lg:mb-18" data-id="element-1814">
          <div className="text-center mb-6 md:mb-8 lg:mb-10" data-id="element-1815">
            <h2 className="text-xl md:text-3xl lg:text-4xl font-black leading-[1.15] max-w-3xl mx-auto" data-id="element-1816">
              Lo Que Voy A Mostrar{' '}
              <span className="text-amber-400" data-id="element-1817">EN VIVO Este Jueves:</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 lg:gap-5 max-w-5xl mx-auto" data-id="element-1818">
            {blocks.map((b, idx) => <div key={b.title} className="group relative bg-white/[0.025] border border-white/[0.08] rounded-2xl p-5 md:p-6 lg:p-7 hover:border-amber-500/40 hover:bg-white/[0.04] transition-all duration-300" data-id="element-1819">
                <div className="flex items-start gap-4" data-id="element-1820">
                  <div className="w-12 h-12 lg:w-14 lg:h-14 rounded-2xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-1821">
                    <b.icon className="w-5 h-5 lg:w-6 lg:h-6 text-amber-400" data-id="element-1822" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-1823">
                    <div className="flex items-center gap-2 mb-2" data-id="element-1824">
                      <span className="text-amber-400 text-[10px] lg:text-xs font-black uppercase tracking-[0.18em]" data-id="element-1825">
                        {b.label}
                      </span>
                    </div>
                    <h3 className="text-base md:text-lg lg:text-xl font-black text-white mb-2 leading-snug" data-id="element-1826">
                      {b.title}
                    </h3>
                    <p className="text-sm md:text-[15px] lg:text-base text-gray-400 leading-relaxed" data-id="element-1827">
                      {b.desc}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </section>

        {/* ============ SECTION 5 — Detalles + Countdown ============ */}
        <section className="mb-10 md:mb-14 lg:mb-18" data-id="element-1828">
          <div className="max-w-4xl mx-auto" data-id="element-1829">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-4 mb-5 lg:mb-7" data-id="element-1830">
              {[{
              icon: Calendar,
              label: 'Fecha',
              value: `Este ${thursdayLabel.split(' ')[0]}`
            }, {
              icon: Clock,
              label: 'Hora',
              value: '7:00 PM hora Miami (EST)'
            }, {
              icon: Video,
              label: 'Duración',
              value: '90 min + 30 min Q&A'
            }, {
              icon: Monitor,
              label: 'Plataforma',
              value: 'Zoom'
            }, {
              icon: DollarSign,
              label: 'Inversión',
              value: '100% GRATIS',
              highlight: true
            }, {
              icon: AlertTriangle,
              label: 'Importante',
              value: 'Es EN VIVO — NO hay reposición',
              warning: true
            }].map(d => <div key={d.label} className={`flex items-start gap-3 rounded-2xl p-4 lg:p-5 border ${d.warning ? 'bg-red-950/20 border-red-500/30' : d.highlight ? 'bg-amber-500/10 border-amber-500/40 shadow-[0_0_30px_rgba(245,158,11,0.12)]' : 'bg-white/[0.03] border-white/[0.08]'}`} data-id="element-1831">
                  <div className={`w-11 h-11 lg:w-12 lg:h-12 rounded-xl flex items-center justify-center flex-shrink-0 border ${d.warning ? 'bg-red-500/10 border-red-500/30' : 'bg-amber-500/10 border-amber-500/30'}`} data-id="element-1832">
                    <d.icon className={`w-5 h-5 ${d.warning ? 'text-red-400' : 'text-amber-400'}`} data-id="element-1833" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-1834">
                    <div className="text-[10px] lg:text-xs font-black uppercase tracking-[0.18em] text-gray-400 mb-1" data-id="element-1835">
                      {d.label}
                    </div>
                    <div className={`font-black text-base lg:text-lg ${d.warning ? 'text-red-400' : d.highlight ? 'text-amber-400' : 'text-white'}`} data-id="element-1836">
                      {d.value}
                    </div>
                  </div>
                </div>)}
            </div>

            {/* Countdown */}
            <div className="relative bg-gradient-to-br from-[#0f1b35] to-[#0a1428] border-2 border-amber-500/40 rounded-3xl p-5 md:p-7 lg:p-9 text-center shadow-[0_0_60px_rgba(245,158,11,0.15)] overflow-hidden" data-id="element-1837">
              <div className="absolute top-0 right-0 w-40 h-40 bg-amber-400/10 blur-3xl rounded-full" data-id="element-1838" />
              <div className="relative" data-id="element-1839">
                <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-5" data-id="element-1840">
                  <Clock className="w-3.5 h-3.5 text-amber-400 animate-pulse" data-id="element-1841" />
                  <span className="text-amber-400 text-[11px] md:text-xs font-black uppercase tracking-widest" data-id="element-1842">
                    El Webinar Empieza En:
                  </span>
                </div>

                <div className="grid grid-cols-4 gap-2 md:gap-4 max-w-2xl mx-auto mb-7" data-id="element-1843">
                  {[{
                  label: 'Días',
                  value: countdown.days
                }, {
                  label: 'Horas',
                  value: countdown.hours
                }, {
                  label: 'Min',
                  value: countdown.minutes
                }, {
                  label: 'Seg',
                  value: countdown.seconds
                }].map(u => <div key={u.label} className="bg-[#0a1428] border border-amber-500/20 rounded-xl py-3 md:py-4 px-2 md:px-3" data-id="element-1844">
                      <div className="text-3xl md:text-4xl lg:text-5xl font-black text-amber-400 tabular-nums leading-none mb-1.5" data-id="element-1845">
                        {String(u.value).padStart(2, '0')}
                      </div>
                      <div className="text-[9px] md:text-[10px] lg:text-xs text-gray-400 uppercase tracking-[0.18em] font-bold" data-id="element-1846">
                        {u.label}
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ============ SECTION 6 — Caso Real Andrés ============ */}
        <section className="mb-10 md:mb-14 lg:mb-18" data-id="element-1847">
          <div className="max-w-5xl mx-auto" data-id="element-1848">
            <div className="text-center mb-5 md:mb-6 lg:mb-8" data-id="element-1849">
              <h2 className="text-xl md:text-3xl lg:text-4xl font-black leading-[1.15] max-w-4xl mx-auto" data-id="element-1850">
                Esto Le Pasó A Andrés Cuando{' '}
                <span className="text-amber-400" data-id="element-1851">Vino Al Webinar:</span>
              </h2>
            </div>

            <div className="bg-gradient-to-br from-amber-950/20 to-[#0a1428] border border-amber-500/20 rounded-3xl p-5 md:p-7 lg:p-9" data-id="element-1852">
              <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 lg:gap-8" data-id="element-1853">
                <div className="lg:col-span-3 space-y-2.5 text-gray-300 text-base lg:text-lg leading-relaxed" data-id="element-1854">
                  <p data-id="element-1855">
                    Recuerdas a Andrés del PDF? El vendedor de Toyota en
                    Phoenix.
                  </p>
                  <p className="text-white font-semibold" data-id="element-1856">
                    Aquí está lo que NO te conté:
                  </p>
                  <p data-id="element-1857">Andrés descargó el PDF un lunes. Lo leyó esa noche.</p>
                  <p data-id="element-1858">
                    Pero NO tomó acción ese lunes. Ni el martes. Ni el
                    miércoles.
                  </p>
                  <p data-id="element-1859">
                    Andrés iba a ser un 'prospecto frío' más. Otro vendedor que
                    descargó el PDF y siguió con su vida.
                  </p>
                  <p className="text-amber-400 font-bold text-xl mt-6" data-id="element-1860">
                    Hasta que vino al webinar el jueves.
                  </p>
                </div>

                {/* Pull quote */}
                <div className="lg:col-span-2 relative bg-white/[0.04] border border-amber-500/30 rounded-2xl p-5 lg:p-6" data-id="element-1861">
                  <Quote className="w-7 h-7 text-amber-400/60 mb-3" data-id="element-1862" />
                  <p className="text-white text-base lg:text-lg font-medium italic leading-snug mb-4" data-id="element-1863">
                    "En el PDF entendí el modelo. En el webinar VI que era real.
                    Cuando viste la herramienta encontrar 200 dentistas en
                    Phoenix en menos de un minuto, dije 'esto es mi salida'.
                    Cuando construiste la web del Dr. González en vivo, dije 'yo
                    puedo hacer esto'. Esa noche le dije a Laura: 'me apunto al
                    programa'."
                  </p>
                  <div className="flex items-center gap-2.5" data-id="element-1864">
                    <div className="w-9 h-9 rounded-full bg-amber-500/15 border border-amber-500/30 flex items-center justify-center" data-id="element-1865">
                      <User className="w-4 h-4 text-amber-400" data-id="element-1866" />
                    </div>
                    <div data-id="element-1867">
                      <div className="text-white font-black text-sm" data-id="element-1868">
                        Andrés
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-8 text-center bg-white/[0.02] border border-white/[0.05] rounded-xl p-5" data-id="element-1869">
                <p className="text-gray-300 text-lg" data-id="element-1870">
                  El PDF te informa. El webinar te decide.{' '}
                  <span className="text-white font-bold" data-id="element-1871">
                    Andrés es la prueba viviente.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ============ SECTION 7 — Botón Principal ============ */}
        <section className="mb-10 md:mb-14 lg:mb-18 text-center" data-id="element-1872">
          <div className="max-w-3xl mx-auto" data-id="element-1873">
            <h2 className="text-xl md:text-3xl lg:text-4xl font-black leading-[1.15] mb-3 md:mb-4" data-id="element-1874">
              Reserva Tu Cupo Para El Jueves:
            </h2>

            <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 rounded-full px-3.5 py-1.5 md:px-4 md:py-2 mb-4 md:mb-5 max-w-full" data-id="element-1875">
              <span className="text-base md:text-xl flex-shrink-0" data-id="element-1876">🔥</span>
              <span className="text-red-400 text-[11px] md:text-base font-bold leading-tight text-left" data-id="element-1877">
                Ya hay más de 340 vendedores registrados — los cupos son
                limitados
              </span>
            </div>

            <button type="button" onClick={() => setShowModal(true)} className="group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base md:text-xl lg:text-2xl uppercase tracking-tight rounded-2xl py-5 md:py-8 px-4 md:px-6 shadow-[0_20px_60px_-15px_rgba(245,158,11,0.6)] hover:shadow-[0_20px_60px_-10px_rgba(245,158,11,0.75)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden mb-4 md:mb-5" data-id="element-1878">
              <span className="relative z-10 flex items-center justify-center gap-3" data-id="element-1879">
                👉 RESERVAR MI CUPO GRATIS PARA EL JUEVES
              </span>
              <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-1880" />
            </button>

            <div className="grid grid-cols-2 md:flex md:flex-row md:items-center md:justify-center gap-x-3 gap-y-2 md:gap-8 text-xs md:text-sm text-gray-400 mb-5 md:mb-6 max-w-md md:max-w-none mx-auto" data-id="element-1881">
              <span className="flex items-center gap-1.5" data-id="element-1882">
                <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-emerald-400 flex-shrink-0" data-id="element-1883" />
                <span className="truncate" data-id="element-1884">30 segundos</span>
              </span>
              <span className="flex items-center gap-1.5" data-id="element-1885">
                <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-emerald-400 flex-shrink-0" data-id="element-1886" />
                <span className="truncate" data-id="element-1887">100% gratis</span>
              </span>
              <span className="flex items-center gap-1.5" data-id="element-1888">
                <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-emerald-400 flex-shrink-0" data-id="element-1889" />
                <span className="truncate" data-id="element-1890">Confirmación inmediata</span>
              </span>
              <span className="flex items-center gap-1.5" data-id="element-1891">
                <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-emerald-400 flex-shrink-0" data-id="element-1892" />
                <span className="truncate" data-id="element-1893">Recordatorios automáticos</span>
              </span>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1894">
              <button className="flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl px-5 py-3 text-sm font-bold transition-colors w-full sm:w-auto justify-center" data-id="element-1895">
                <CalendarPlus className="w-4 h-4 text-amber-400" data-id="element-1896" />
                Agregar a Google Calendar
              </button>
              <button className="flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl px-5 py-3 text-sm font-bold transition-colors w-full sm:w-auto justify-center" data-id="element-1897">
                <CalendarPlus className="w-4 h-4 text-amber-400" data-id="element-1898" />
                Agregar a Apple Calendar
              </button>
              <button className="flex items-center gap-2 bg-[#25D366]/10 hover:bg-[#25D366]/20 border border-[#25D366]/30 text-[#25D366] rounded-xl px-5 py-3 text-sm font-bold transition-colors w-full sm:w-auto justify-center" data-id="element-1899">
                <MessageCircle className="w-4 h-4" data-id="element-1900" />
                Activar Recordatorios
              </button>
            </div>
          </div>
        </section>

        {/* ============ SECTION 8 — CTA Final Emocional ============ */}
        <section className="mb-8" data-id="element-1901">
          <div className="max-w-3xl mx-auto" data-id="element-1902">
            <div className="relative bg-gradient-to-br from-[#0f1b35] to-[#0a1428] border-2 border-amber-500/40 rounded-3xl p-5 md:p-8 lg:p-10 shadow-[0_0_60px_rgba(245,158,11,0.15)] overflow-hidden" data-id="element-1903">
              <div className="absolute -inset-2 bg-amber-400/20 blur-3xl rounded-3xl pointer-events-none" data-id="element-1904" />
              <div className="relative" data-id="element-1905">
                <h2 className="text-xl md:text-3xl font-black leading-[1.15] mb-4 md:mb-6 text-center" data-id="element-1906">
                  Si Sigues Aquí, Es Por Una Razón
                </h2>

                <div className="space-y-2.5 md:space-y-3 text-gray-300 text-sm md:text-lg leading-relaxed mb-5 md:mb-6" data-id="element-1907">
                  <p data-id="element-1908">Llegaste hasta el final.</p>
                  <p data-id="element-1909">
                    La mayoría que descarga el PDF cierra esta página en los
                    primeros 30 segundos. Tú no.
                  </p>
                  <p data-id="element-1910">Eso me dice algo importante de ti.</p>
                </div>

                <div className="text-center mb-5 md:mb-6" data-id="element-1911">
                  <p className="text-lg md:text-3xl font-black text-white leading-snug mb-4 md:mb-5" data-id="element-1912">
                    ¿El jueves a las 7 PM vas a estar viendo la Masterclass
                    conmigo?
                  </p>

                  <button type="button" onClick={() => setShowModal(true)} className="group relative inline-flex items-center justify-center gap-2 bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-sm md:text-xl uppercase tracking-tight rounded-xl py-4 px-5 md:px-8 shadow-[0_0_30px_rgba(245,158,11,0.4)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden w-full md:w-auto" data-id="element-1913">
                    <span className="relative z-10" data-id="element-1914">
                      👉 SÍ, QUIERO RESERVAR MI CUPO
                    </span>
                    <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-1915" />
                  </button>
                </div>

                <div className="border-t border-white/10 pt-5 md:pt-8 space-y-3 md:space-y-4 text-gray-400 text-sm md:text-lg italic" data-id="element-1916">
                  <p data-id="element-1917">Hermano, nos vemos el jueves a las 7 PM hora Miami.</p>
                  <p data-id="element-1918">Y mientras tanto — abre el email, lee el PDF.</p>
                  <p data-id="element-1919">
                    Empieza por el capítulo 4 (la historia de Andrés). Te va a
                    abrir los ojos.
                  </p>
                  <p className="font-bold text-white not-italic mt-5 md:mt-6" data-id="element-1920">
                    — Gabriel
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1921" />

      {/* Registration Modal */}
      {showModal && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowModal(false)} data-id="element-1922">
          <div className="bg-[#0f1b35] border border-amber-500/30 rounded-2xl max-w-md w-full p-6 md:p-8 relative shadow-[0_0_50px_rgba(245,158,11,0.2)] max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-1923">
            <button onClick={() => setShowModal(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors p-1" aria-label="Cerrar" data-id="element-1924">
              <X className="w-6 h-6" data-id="element-1925" />
            </button>

            <div className="text-center mb-6" data-id="element-1926">
              <div className="inline-flex items-center justify-center w-14 h-14 bg-amber-500/10 border border-amber-500/30 rounded-2xl mb-3" data-id="element-1927">
                <Ticket className="w-6 h-6 text-amber-400" data-id="element-1928" />
              </div>
              <h2 className="text-2xl md:text-3xl font-black text-white mb-2 uppercase tracking-tight" data-id="element-1929">
                Reservar Mi Cupo
              </h2>
              <p className="text-gray-400 text-sm" data-id="element-1930">
                Masterclass EN VIVO — Este {thursdayLabel} 7PM Miami
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1931">
              <div className="space-y-1" data-id="element-1932">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-1933">
                  Nombre Completo
                </label>
                <div className="relative" data-id="element-1934">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-1935">
                    <User className="h-5 w-5 text-gray-500" data-id="element-1936" />
                  </div>
                  <input ref={nameRef} type="text" name="name" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre" required minLength={2} autoComplete="name" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-1937" />
                </div>
              </div>

              <div className="space-y-1" data-id="element-1938">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-1939">
                  Tu Mejor Email
                </label>
                <div className="relative" data-id="element-1940">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-1941">
                    <Mail className="h-5 w-5 text-gray-500" data-id="element-1942" />
                  </div>
                  <input ref={emailRef} type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ejemplo@correo.com" required autoComplete="email" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-1943" />
                </div>
              </div>

              <div className="space-y-1" data-id="element-1944">
                <label className="text-xs font-bold text-gray-400 uppercase ml-2" data-id="element-1945">
                  WhatsApp (Para Recordatorios)
                </label>
                <div className="flex gap-2" data-id="element-1946">
                  <div className="relative w-1/3" data-id="element-1947">
                    <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none" data-id="element-1948">
                      <Globe className="h-4 w-4 text-gray-500" data-id="element-1949" />
                    </div>
                    <select name="areaCode" value={areaCode} onChange={e => setAreaCode(e.target.value)} className="w-full pl-8 pr-2 py-3 rounded-xl bg-white/5 border border-white/10 text-white focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all appearance-none text-sm" data-id="element-1950">
                      {COUNTRY_CODES.map(c => <option key={c.code} value={c.code} className="bg-gray-900" data-id="element-1951">
                          {c.code} {c.country}
                        </option>)}
                    </select>
                  </div>

                  <div className="relative w-2/3" data-id="element-1952">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-1953">
                      <Phone className="h-5 w-5 text-gray-500" data-id="element-1954" />
                    </div>
                    <input ref={phoneRef} type="tel" name="phone" value={phone} onChange={e => setPhone(e.target.value.replace(/\D/g, ''))} placeholder="Número" required minLength={7} autoComplete="tel" className="w-full pl-12 pr-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none focus:border-amber-400 focus:bg-white/10 transition-all" data-id="element-1955" />
                  </div>
                </div>
              </div>

              <label className="flex items-start gap-3 cursor-pointer group pt-1" data-id="element-1956">
                <div className="relative flex-shrink-0 mt-0.5" data-id="element-1957">
                  <input type="checkbox" checked={smsConsent} onChange={e => setSmsConsent(e.target.checked)} className="sr-only peer" data-id="element-1958" />
                  <div className="w-5 h-5 border-2 border-gray-500 rounded bg-white/5 peer-checked:bg-amber-400 peer-checked:border-amber-400 transition-all flex items-center justify-center" data-id="element-1959">
                    {smsConsent && <CheckCircle2 className="w-3.5 h-3.5 text-[#0a1428]" strokeWidth={3} data-id="element-1960" />}
                  </div>
                </div>
                <span className="text-[11px] md:text-xs text-gray-400 leading-relaxed" data-id="element-1961">
                  Acepto recibir mensajes SMS con recordatorios e información
                  del webinar. Puedo cancelar en cualquier momento respondiendo
                  STOP.
                </span>
              </label>

              <button type="submit" disabled={isSubmitting} className="group relative w-full bg-gradient-to-b from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-[#0a1428] font-black text-base md:text-lg uppercase tracking-tight rounded-xl py-4 px-6 shadow-[0_0_30px_rgba(245,158,11,0.4)] transition-all duration-300 transform hover:scale-[1.01] disabled:opacity-60 disabled:cursor-not-allowed overflow-hidden" data-id="element-1962">
                <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-1963">
                  {isSubmitting ? <>Reservando...</> : <>
                      <Ticket className="w-4 h-4 md:w-5 md:h-5" data-id="element-1964" />
                      RESERVAR MI CUPO AHORA
                      <ArrowRight className="w-4 h-4 md:w-5 md:h-5 transition-transform group-hover:translate-x-1" data-id="element-1965" />
                    </>}
                </span>
                <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine pointer-events-none" data-id="element-1966" />
              </button>

              <div className="flex items-center justify-center gap-1.5 text-[10px] md:text-xs text-gray-500 pt-1" data-id="element-1967">
                <Lock className="w-3 h-3" data-id="element-1968" />
                Tu información está 100% segura
              </div>
            </form>
          </div>
        </div>}
    </div>;
}